import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './ProductInfo.style'

const ProductInfoVariationThirtyFleetFinancing = (props) => {
  const styles = useStyles()
  const { t } = props
  return (
    <Box
      style={{
        width: 'calc(30% - 10px)',
      }}
      className={styles.thirtyVariantRootFleetFinancing}
    >
      <Typography variant="h6">{t(props.title)}</Typography>
      <Box className={styles.iconListContainer}>
        {props.iconList &&
          props.iconList.map((items, index) => (
            <Box className={styles.iconListItemFleetFinancing} key={index}>
              {items.icon}
              <Typography variant="body2">{t(items.description)}</Typography>
            </Box>
          ))}
      </Box>
      <Typography className={styles.footerText}>
        {t(props.footerText)}
      </Typography>
    </Box>
  )
}

export default ProductInfoVariationThirtyFleetFinancing
